export class Roles {
    static superAdministrator = 'SuperAdministrator';
    static systemAdministrator = 'SystemAdministrator';
    static hospitalAdministrator = 'HospitalAdministrator';
    static stockIssuer = 'StockIssuer';
    static creditRequester = 'CreditRequester';
    static creditApprover = 'CreditApprover';
    static reportViewer = 'ReportViewer';
    static theatre = 'Theatre';
    static emergencyCupboardStockIssuer = 'EmergencyCupboardStockIssuer';
    static materialTransfer = 'MaterialTransfer';
    static pharmacy = 'Pharmacy';
    static preAdmission = 'PreAdmission';
    static tisScoring = 'TisScoring';
    static stockCountManager = 'StockCountManager';
    static stockCountCounter = 'StockCountCounter';
    static stockCountAuditor = 'StockCountAuditor';
    
}

